import React from "react";

export const TransactionBanner = React.memo(function TransactionBanner({ txBanner }) {
  if (!txBanner) return null;

  const { ok, message, txid } = txBanner;

  return (
    <div className={`nr-txBanner ${ok ? "nr-txBannerOk" : "nr-txBannerErr"}`}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span>{message}</span>
        {txid ? (
          <a
            className="nr-link"
            href={`https://proton.bloks.io/transaction/${txid}`}
            target="_blank"
            rel="noreferrer"
            style={{ fontSize: 12 }}
          >
            View on Bloks
          </a>
        ) : null}
      </div>
    </div>
  );
});
